<template>
  <v-dialog v-model="modalAberto" max-width="800px">
    <v-card>
      <v-card-title> Editar Evento </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="emitirEvento">
          <v-select
            v-model="novoEvento.evento_id"
            label="Tipo de Evento"
            :items="eventosList"
            item-text="text"
            item-value="id"
            required
          ></v-select>

          <v-textarea
            v-model="novoEvento.descricao"
            label="Descrição do Evento"
            outlined
            dense
            rows="3"
            required
            maxlength="70"
            counter
          ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="emitirEvento" :disabled="!isFormValid || loading">
          <v-progress-circular
            v-if="loading"
            indeterminate
            size="20"
            color="white"
          ></v-progress-circular>
          <span v-else>Salvar Alterações</span>
        </v-btn>
        <v-btn dark color="grey" @click="fecharModal" :disabled="loading">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    modalAberto: Boolean,
    novoEvento: Object,
    eventosList: Array,
    loading: Boolean,
  },
  computed: {
    isFormValid() {
      return this.novoEvento.evento_id && this.novoEvento.descricao;
    },
  },
  methods: {
    emitirEvento() {
      this.$emit("editar-evento");
    },
    fecharModal() {
      this.$emit("fechar-modal");
    },
  },
};
</script>
